import React, { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAppSelector } from '@/store/hooks';
import { refreshActiveTable } from '@/store/reducers/table-slice';
import { getUi, hideModal } from '@/store/reducers/ui-slice';
import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';

function DeleteMediaItemContent(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  const content = modal?.content as {
    mediaId: string;
    path: string;
  };

  const urlSearchParams = useSearchParams();
  const selectedOpId = urlSearchParams.get('opId') || undefined;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = (): void => {
    dispatch(hideModal());
  };

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await fetch(`/api/cms/gallery?mediaId=${content?.mediaId}&opId=${selectedOpId}`, {
        method: 'DELETE',
      });
      const result = await response.json();
      if (response.ok && result.success && result.data) {
        toast.success('Media item deleted successfully!');
        dispatch(hideModal());
        dispatch(refreshActiveTable());
      } else {
        toast.error('Error: 500 | Unable to delete Media item');
      }
    } catch (e) {
      toast.error('Error: 500 | Unable to delete Media item');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Typography variant="body2">Are you sure you want to delete this media item?</Typography>

      <Stack direction="row" spacing={3} sx={{ mt: 3, justifyContent: 'initial' }}>
        <Button type="button" color="secondary" onClick={handleClose} sx={{ flex: '1 1 auto' }}>
          Close
        </Button>

        <Button loading={isLoading} onClick={handleSubmit} color="error" sx={{ flex: '1 1 auto' }} variant="contained">
          Delete
        </Button>
      </Stack>
    </Stack>
  );
}

export default DeleteMediaItemContent;
